import {Component, computed, input} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {Badge} from 'primeng/badge';

@Component({
  selector: 'app-wizard-phase-header',
  imports: [TranslocoPipe, Badge],
  templateUrl: './wizard-phase-header.component.html',
})
export class WizardPhaseHeaderComponent {
  readonly phase = input.required<string>();
  readonly companyName = input.required<string>();
  readonly projectName = input.required<string>();

  protected readonly titleKey = computed(
    () => `provider.tenderWizard.${this.phase().toLowerCase()}.title`,
  );
}
